import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { HttpRequest, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  loggingInterceptor,
  OryFailedRequestCacheInterceptor,
  SSRCookieInterceptor,
  SSRPerformanceInterceptor,
  SSRSetCookieForResponseInterceptor
} from './auth/interceptor';
import { AuthService } from './auth/auth.service';
import { SRC_GENERATOR_SERVICE } from '@irohalab/deneb-ui';
import { KratosApiModule, KratosConfiguration } from '../sdk/kratos';
import { environment } from '../environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { UserAccountService } from './user-account.service';
import { BangumiProviderService } from './bangumi-provider.service';
import { BangumiProviderApiModule, BangumiProviderConfiguration } from '../sdk/bangumiProvider';
import { MiraApiModule, MiraConfiguration } from '@irohalab/mira-sdk-angular';
import { ImageKitSrcGeneratorService } from './image-kit-src-generator.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withHttpTransferCacheOptions({
      filter: (req: HttpRequest<unknown>) => {
        // console.log(req.method + ' ' + req.url);
        return true;
      }
    })),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        SSRPerformanceInterceptor,
        SSRSetCookieForResponseInterceptor,
        OryFailedRequestCacheInterceptor,
        SSRCookieInterceptor,
        // loggingInterceptor
      ])
    ),
    {provide: AuthService, useClass: AuthService},
    {provide: UserAccountService, useClass: UserAccountService},
    provideAnimations(),
    importProvidersFrom(
      KratosApiModule.forRoot(() => new KratosConfiguration({
        basePath: environment.kratosBasePath,
        withCredentials: true
      })),
      BangumiProviderApiModule.forRoot(() => new BangumiProviderConfiguration({
        basePath: environment.bangumiProviderBasePath + '/api',
        withCredentials: true
      })),
      MiraApiModule.forRoot(() => new MiraConfiguration({
        basePath: environment.bangumiProviderBasePath + '/api',
        withCredentials: true
      }))
    ),
    {provide: BangumiProviderService, useClass: BangumiProviderService},
    {provide: SRC_GENERATOR_SERVICE, useClass: ImageKitSrcGeneratorService}
  ]
};
